import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'helpers/CSSModulesUtil'
import T from 'i18n-react'
import { Button } from 'react-toolbox/lib/button'

import notifyHoc from 'containers/App/Notification/Notify'

import styles from './styles.scss'

const NotifyButton = notifyHoc(Button)

const ButtonComponent = (props) => {
  const { styles, ...rest } = props
  return (
    <div styleName='drawerButton'>
      <NotifyButton
        {...rest}
        theme={styles}
      />
    </div>
  )
}

const withStyle = CSSModules(styles)

export default withStyle(ButtonComponent)